<template>
  <g>
    <path
      d="M2.02548 9.9671C1.63882 9.42884 1.76171 8.67904 2.29997 8.29238C2.83823 7.90573 3.58803 8.02862 3.97468 8.56688C4.33931 9.07447 4.90176 9.55864 5.63019 9.97911C7.18224 10.875 9.33255 11.4 11.6452 11.4C13.9578 11.4 16.1081 10.875 17.6602 9.97911C18.3886 9.55864 18.951 9.07447 19.3157 8.56688C19.7023 8.02862 20.4521 7.90573 20.9904 8.29238C21.5286 8.67904 21.6515 9.42884 21.2649 9.9671C20.6883 10.7697 19.8682 11.4757 18.8601 12.0576C16.9259 13.1741 14.3622 13.8 11.6452 13.8C8.92811 13.8 6.36443 13.1741 4.43037 12.0576C3.42217 11.4757 2.60206 10.7697 2.02548 9.9671Z"
    />
    <path
      d="M13.2 13.2C13.2 12.5372 12.6627 12 12 12C11.3373 12 10.8 12.5372 10.8 13.2V16.2C10.8 16.8628 11.3373 17.4 12 17.4C12.6627 17.4 13.2 16.8628 13.2 16.2V13.2Z"
    />
    <path
      d="M6.63581 12.9091C6.79655 12.2661 7.44806 11.8752 8.09102 12.0358C8.73397 12.1966 9.12488 12.8481 8.96414 13.4911L8.36414 15.8911C8.20342 16.534 7.55189 16.925 6.90894 16.7642C6.26598 16.6035 5.87507 15.952 6.03581 15.3091L6.63581 12.9091Z"
    />
    <path
      d="M16.7642 12.9091C16.6034 12.2661 15.9519 11.8752 15.309 12.0358C14.666 12.1966 14.2751 12.8481 14.4359 13.4911L15.0359 15.8911C15.1965 16.534 15.848 16.925 16.491 16.7642C17.1339 16.6035 17.5249 15.952 17.3642 15.3091L16.7642 12.9091Z"
    />
    <path
      d="M19.8299 9.95157C19.3613 9.48294 18.6015 9.48294 18.1329 9.95157C17.6641 10.4202 17.6641 11.18 18.1329 11.6486L20.5329 14.0486C21.0015 14.5172 21.7613 14.5172 22.2299 14.0486C22.6985 13.58 22.6985 12.8202 22.2299 12.3516L19.8299 9.95157Z"
    />
    <path
      d="M3.69331 9.993C4.13906 9.50256 4.89799 9.46633 5.38844 9.91208C5.87888 10.3578 5.9151 11.1168 5.46936 11.6072L3.28804 14.0072C2.8423 14.4977 2.08336 14.5339 1.59292 14.0881C1.10247 13.6424 1.06625 12.8834 1.512 12.393L3.69331 9.993Z"
    />
  </g>
</template>
